export default __webpack_public_path__ + "static/favicon-3a91059722eda059d1140789cee6891a.ico";